import React, { useEffect, useState } from 'react';
interface ConfettiProps {
  active: boolean;
  duration?: number;
}
export function Confetti({
  active,
  duration = 3000
}: ConfettiProps) {
  const [particles, setParticles] = useState<Array<{
    id: number;
    left: number;
    delay: number;
    duration: number;
    color: string;
  }>>([]);
  useEffect(() => {
    if (active) {
      const colors = ['#3B82F6', '#8B5CF6', '#EC4899', '#F59E0B', '#10B981', '#EF4444'];
      const newParticles = Array.from({
        length: 50
      }, (_, i) => ({
        id: i,
        left: Math.random() * 100,
        delay: Math.random() * 200,
        duration: 2000 + Math.random() * 1000,
        color: colors[Math.floor(Math.random() * colors.length)]
      }));
      setParticles(newParticles);
      const timer = setTimeout(() => {
        setParticles([]);
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [active, duration]);
  if (!active || particles.length === 0) return null;
  return <div className="fixed inset-0 pointer-events-none z-50 overflow-hidden" data-id="element-679">
      {particles.map(particle => <div key={particle.id} className="absolute top-0 w-2 h-2 rounded-full animate-confetti" style={{
      left: `${particle.left}%`,
      backgroundColor: particle.color,
      animationDelay: `${particle.delay}ms`,
      animationDuration: `${particle.duration}ms`
    }} data-id="element-680" />)}
    </div>;
}